var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed bg-white w-full h-full top-0 left-0 transition transform translate-y-0 z-50 duration-300",class:[_vm.isOpen ? 'translate-y-0 shadow-fullview':'translate-y-full']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }